import type {
  RohsComponentComplianceFileDetailView,
  RohsComponentEvidenceSlot,
} from '@/shared/hooks/api/rohsComplianceFiles'

export function getRohsComponentSlotFileName(
  file: RohsComponentComplianceFileDetailView,
  slotKind: RohsComponentEvidenceSlot
): string | null {
  return file.slots.find((slot) => slot.slotKind === slotKind)?.fileName ?? null
}
